import React from 'react';
import { useSelector } from "react-redux";
import './slider.styles.scss';

const Slider = () => {
  const xprops = useSelector(state => state);
  return (
    <React.Fragment>
      <div className="sliderID">
        <div className="sliderWrapper">
          <div className="sliderQuoteWrapper">
            <span className="sliderAttachLeft"></span>
            {
              xprops.project.language.short === "TR" ?
              <React.Fragment>
                <h2 className="sliderQuote" title="SEN OL Kİ MEDYANIN SESİ TAM OLSUN">SEN OL Kİ MEDYANIN SESİ TAM OLSUN</h2>
                <p className="sliderText">
                  <strong>"Sensiz Olmaz Sessiz Olmaz"</strong>, kadınların her alanda daha güçlü, daha görünür ve daha etkili olmalarını desteklemek amacıyla kurulmuş bir sosyal girişimdir. Bu girişim kadınların, toplumsal ve bireysel yaşamda karşılaştıkları engelleri aşmalarına yardımcı olacak araçlar ve ortamlar paylaşmayı, medya ve kamusal alanda seslerini daha güçlü duyurabilmeleri için olanaklar sağlamayı amaçlar. 
                </p>
                <p className="sliderText">
                Sensiz Olmaz Sessiz Olmaz, kadın uzmanlardan oluşan veri tabanı ve eğitimler ile kadınların birikimlerini medyada duyurmalarına olanak tanır. Sessiz Olmaz blog ve sosyal medya platformları üzerinden farkındalık çalışmaları desteklenerek  kadınların görünür olması, koçluk programlarıyla ise iş hayatında güçlenmesi hedefleniyor. 
                </p>
                <p className="sliderText">
                  <span className="sliderAttachRight"></span>
                </p>
              </React.Fragment>
              :
              <React.Fragment>
              <h2 className="sliderQuote" title="Women Voices Matter">Women Voices Matter</h2>
              <p className="sliderText EN">
                <strong>{xprops.project.language.metas.title}</strong> is a social initiative established to support women in becoming stronger, more visible, and more influential, especially in their professional lives and public arenas. This initiative aims to provide tools and environments that help women overcome barriers they face in social and individual life, and to create opportunities for them to make their voices heard more strongly in the media and public spaces.
              </p>
              <p className="sliderText EN">
                With its database of women experts and training programs, {xprops.project.language.metas.title} enables women to broadcast their expertise in the media. Through the Sessiz Olmaz blog and social media platforms, awareness efforts are supported to increase women's visibility, while coaching programs aim to strengthen them in their professional lives.
                <span className="sliderAttachRight EN"></span>
              </p>

              </React.Fragment>
            }
          </div>        
        </div>
      </div>
    </React.Fragment>
  );
}

export default Slider;